<div class="extended-option-container">
    <div id="extendedMapOptions" class="map-options-dialog">
        <ul class="map-option-list">
            <li (click)="selectRiskType()" id="dustOption" [class.selected]="isDust">{{ "Dust Map" | translate }}</li>
            <li (click)="selectRiskType('Zoned Risk Map')" id="zoneRiskOption" [class.selected]="isZonedRisk">{{ "Zoned Risk Map" | translate }}</li>
        </ul>
        <ul class="map-option-list">
            <li>
                <input type="checkbox" (change)="showNodes()" [checked]="displayNodes" class="map-node-select">
                <label class="map-node-label">{{ "Show Nodes" | translate }}</label>
            </li>
            <li>
                <input type="checkbox" (change)="showWindData()" [checked]="displayWindDirection" class="map-node-select">
                <label class="map-node-label">{{ "Show Wind Data" | translate }}</label>
            </li>
            <li class="d-flex">
                <input type="checkbox" (change)="showAirNowSensorsData()" [checked]="displayAirNowSensorsData" class="map-node-select">
                <label class="map-node-label">{{ "Show AIR Now Sensors" | translate }}</label>
            </li>
        </ul>
    </div>
    <button class='extended-map-options' title='Toggle Heatmap' type='button' (click)="toggleOptionDisplay()">
        <img src="assets/images/google-maps/toggle-heatmap.png">
    </button>
</div>